import modalErrorLocalizations from './modalErrorLocalizations.json';

export default modalErrorLocalizations;
